// src/components/Logout.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../context/AppConfig';

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Clear any stored authentication tokens
      localStorage.removeItem('token');  // Clear the token (if using JWT)
      
      // Optional: Inform the backend (session-based)
      await fetch(`${BASE_URL}/logout/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        credentials: 'include', // If using cookies for sessions
      });

      // Redirect to login page
      navigate('/signin');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <button onClick={handleLogout} className="btn btn-danger">
      Logout
    </button>
  );
};

export default Logout;
